import { GetStaticProps } from 'next';
import React from 'react';

import RichText from 'components/RichText/RichText';
import { transitionVariants } from 'components/TransitionBackground/TransitionBackground';
import { queryCMS } from 'utils/cms/api';
import { pricacyPage } from 'utils/cms/gql';
import { ISR_TIMEOUT } from 'utils/config';

import * as S from './PrivacyPage.styles';

export interface PrivacyPageProps {
  className?: string;
  data: {
    title: string;
    content: string;
  };
}

const defaultProps: Partial<PrivacyPageProps> = {};

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  const response = await queryCMS({
    query: pricacyPage({
      locale,
    }),
  });

  const { privacy } = response;

  return {
    props: {
      sharedCopy: response.sharedCopy,
      data: privacy,
      pageData: response,
      footer: response.footer,
      head: response.privacy.head,
      cookies: response.cookieBar,
    },
    revalidate: ISR_TIMEOUT,
  };
};

const PrivacyPage: React.FC<PrivacyPageProps> = ({
  className,
  data,
}: PrivacyPageProps) => {
  return (
    <S.Wrapper
      className={className}
      initial="initial"
      animate="animate"
      exit="exit"
      variants={transitionVariants}
    >
      {/* <S.Background /> */}
      <S.Display dangerouslySetInnerHTML={{ __html: data.title }} />
      <S.Content>
        <RichText richText={data.content} />
      </S.Content>
    </S.Wrapper>
  );
};

PrivacyPage.defaultProps = defaultProps;

export default PrivacyPage;
